<template>
  <AdminLayout>
    <v-row align="stretch" class="mb-16 gutters">
      <v-col cols="12" class="mx-xs-auto d-flex flex-column height">
        <v-text-field
          v-model="search"
          label="Mandant suchen..."
          append-inner-icon="mdi-magnify"
          variant="solo"
          clearable
          class="search-field"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="api.tenants"
          :sort-by="['name']"
          :search="search"
          :footer-props="{
            'items-per-page-all-text': 'Alle',
            'items-per-page-text': 'Mandanten pro Seite',
          }"
          class="bg-accent elevation-1"
          fixed-header
          :loading="loading"
          loading-text="Daten werden geladen..."
        >
          <template #loader>
            <v-progress-linear
              indeterminate
              color="primary"
              height="4"
            ></v-progress-linear>
          </template>
          <template v-slot:item.controls="{ item }">
            <span>
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props" size="small">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    link
                    @click="onOpenEditTenant(item.id)"
                    prepend-icon="mdi-pencil"
                  >
                    <v-list-item-title>Mandanten bearbeiten</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    link
                    @click="onOpenDeleteDialog(item.id)"
                    prepend-icon="mdi-delete"
                  >
                    <v-list-item-title>Mandanten löschen</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <TenantEditDialog
      v-if="selectedTenant.id"
      :open="openEditDialog"
      :tenant-id="selectedTenant.id"
      @close="onCloseDialog"
    ></TenantEditDialog>
    <DeleteConformationDialog
      :open="openDeleteDialog"
      :toDelete="selectedTenant"
      @close="onCloseDeleteDialog"
    />
  </AdminLayout>
</template>

<script>
import AdminLayout from "@/layouts/Admin.vue";
import { mapActions, mapGetters } from "vuex";
import ApiTenantService from "@/services/api/ApiTenantService";
import DeleteConformationDialog from "@/components/Tenant/tenantDeleteConformationDialog";
import Tenant from "@/entities/tenant";
import TenantEditDialog from "@/components/Tenant/TenantEditDialog.vue";

export default {
  components: {
    DeleteConformationDialog,
    AdminLayout,
    TenantEditDialog,
  },
  data() {
    return {
      search: "",
      api: {
        tenants: [],
      },
      headers: [
        {
          title: "Id",
          align: "start",
          value: "id",
          sortable: false,
        },
        { title: "Name", value: "name", sortable: true },
        { title: "Kontakt Person", value: "contactName", sortable: true },
        { title: "Adresse", value: "location", sortable: true },
        { title: "E-Mail Adresse", value: "mail", sortable: true },
        { title: "Telefonnummer", value: "phone", sortable: true },
        { title: "", value: "controls", sortable: false },
      ],
      openEditDialog: false,
      openDeleteDialog: false,
      selectedTenant: {},
      tenantCountCheck: true,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      startLoading: "loading/start",
      stopLoading: "loading/stop",
    }),
    fetchTenants() {
      this.startLoading("fetch-tenants");
      ApiTenantService.getTenants()
        .then((response) => {
          this.api.tenants = response.data;
        })
        .finally(() => {
          this.stopLoading("fetch-tenants");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onOpenEditTenant(tenantId) {
      this.selectedTenant = Object.assign(
        {},
        this.api.tenants.find((tenant) => tenant.id === tenantId)
      );
      this.openEditDialog = true;
    },
    async onCloseDialog() {
      this.fetchTenants();
      this.openEditDialog = false;
      await this.getTenantCountCheck();
    },
    onOpenDeleteDialog(tenantId) {
      this.selectedTenant = Object.assign(
        {},
        this.api.tenants.find((tenant) => tenant.id === tenantId)
      );
      this.openDeleteDialog = true;
    },
    async onCloseDeleteDialog() {
      this.fetchTenants();
      this.openDeleteDialog = false;
      await this.getTenantCountCheck();
    },
    onOpenCreateTenant() {
      this.selectedTenant = new Tenant();
      this.openEditDialog = true;
    },
    async getTenantCountCheck() {
      this.tenantCountCheck = await ApiTenantService.tenantCountCheck();
    },
  },
  async mounted() {
    await this.getTenantCountCheck();
  },
  created() {
    this.fetchTenants();
  },
};
</script>

<style scoped>
.search-field {
  border-radius: 15px;
}
.custom-alert {
  border-radius: 15px !important;
}
</style>
